<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>APP分享</h1>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page">

      <!-- <div>
        <ul class="list-group-item large">
          <li class="list-group">
            <div class="liner"></div>
            <a class="block clearfix padding-15" v-tap="showShareBar(shareInfoTeacher)">
              <img class="pull-left" src="../../assets/images/logo-yd.png" width="80" height="80">
              <div class="pull-left"><span class="font-16 margin-x-15" style="line-height:80px">园点端2.0</span></div>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="block clearfix padding-15" v-tap="showShareBar(shareInfoParents)">
              <img class="pull-left" src="../../assets/images/logo-parent.png" width="80" height="80">
              <div class="pull-left"><span class="font-16 margin-x-15" style="line-height:80px">家长端2.0</span></div>
            </a>
          </li>
        </ul>
      </div> -->

      <div class="bg-white share-wrap" style="margin-top:10px;">
        <div class="liner"></div>
        <a @click.prevent="showShareBar(shareInfoTeacher), popupVisibleAppshare = true" class="block share share-yd margin-x-15">
          <span class="font-16">园点端</span>
          <p class="gray">强大的学生托管招生管理神器</p>
        </a>
        <span class="img-ewm" @click="isShowArray.ewmTeacher = true, popupVisibleAppTewm = true">二维码</span>
      </div>

      <div class="bg-white share-wrap">
        <div class="liner"></div>
        <a @click.prevent="showShareBar(shareInfoParents), popupVisibleAppshare = true" class="block share share-parent margin-x-15">
          <span class="font-16">家长端</span>
          <p class="gray">看得见的托管，家长放心安心的好伙伴</p>
        </a>
        <span class="img-ewm" @click="isShowArray.ewmParent = true, popupVisibleAppPewm = true">二维码</span>
      </div>

    </div>
        
    <mt-popup 
    v-model="popupVisibleAppshare"
    position="bottom"> 
      <div class="text-center shall font-10 bg-white">
        <div class="clearfix padding-15">
          <div class="col-xs-3"><a class="icon-weixin icon gray" @click.prevent="shareToFriends()">微信好友</a></div>
          <div class="col-xs-3"><a class="icon-qq icon gray" @click.prevent="shareQQ()">QQ好友</a></div>
          <div class="col-xs-3"><a class="icon-qzone icon gray" @click.prevent="shareQQ()">QQ空间</a></div>
          <div class="col-xs-3"><a class="icon-friend icon gray" @click.prevent="shareToTimeLine()">微信朋友圈</a></div>
        </div>
      </div>
      </mt-popup>
   
      <mt-popup 
      v-model="popupVisibleAppTewm"> 
      <div>
        <div class="text-center bg-white padding-15" style="margin:30px">
          <img src="../../assets/images/ewm-teacher.png" width="100%">
          <span class="block padding-15">扫一扫，下载园点端</span>
        </div>
      </div>
      </mt-popup>


      <mt-popup 
      v-model="popupVisibleAppPewm"
      popup-transition="popup-fade">
      <div>
        <div class="text-center bg-white padding-15" style="margin:30px">
          <img src="../../assets/images/ewm-parent.png" width="100%">
          <span class="block padding-15">扫一扫，下载家长端</span>
        </div>
      </div>
      </mt-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isShowArray: {share: false, ewmTeacher: false, ewmParent: false},
      shareInfoTeacher: {title: '少儿之家园点端', description: '强大的学生托管招生管理神器', thumb: 'http://download.shurenapp.com/logo-yd-60.png', webpageUrl: 'http://www.shurenapp.com/vma-trusttee/tintrowap/teacherApp', imageUrl: 'http://download.shurenapp.com/logo-yd-60.png'},
      shareInfoParents: {title: '少儿之家家长端', description: '看得见的托管，让家长安心、放心', thumb: 'http://download.shurenapp.com/logo-parent-60.png', webpageUrl: 'http://www.shurenapp.com/vma-trusttee/tintrowap/parentsApp', imageUrl: 'http://download.shurenapp.com/logo-parent-60.png'},
      info: {},
      popupVisibleAppshare: false,
      popupVisibleAppTewm: false,
      popupVisibleAppPewm: false
    }
  },
  mounted: function () {
  },
  methods: {
    showShareBar: function (para) {
      this.info.title = para.title
      this.info.description = para.description
      this.info.thumb = para.thumb
      this.info.webpageUrl = para.webpageUrl
      this.info.imageUrl = para.imageUrl
      this.isShowArray.share = true
    },
    shareToTimeLine: function () {
      window.Wechat.share({
        message: {
          title: this.info.title,
          description: this.info.description,
          thumb: this.info.thumb,
          messageExt: this.info.title,
          media: {
            type: window.Wechat.Type.LINK,
            webpageUrl: this.info.webpageUrl
          }
        },
        scene: window.Wechat.Scene.TIMELINE   // share to Timeline
      }, function () {
        // alert('分享成功')
      }, function (reason) {
        // alert('失败原因: ' + reason)
      })
    },
    shareToFriends: function () {
      window.Wechat.share({
        message: {
          title: this.info.title,
          description: this.info.description,
          thumb: this.info.thumb,
          messageExt: this.info.title,
          media: {
            type: window.Wechat.Type.LINK,
            webpageUrl: this.info.webpageUrl
          }
        },
        scene: window.Wechat.Scene.SESSION
      }, function () {
        // alert('分享成功')
      }, function (reason) {
        // alert('失败原因:' + reason)
      })
    },
    shareQQ: function () {
      var args = {}
      args.url = this.info.webpageUrl
      args.title = this.info.title
      args.description = this.info.description
      args.imageUrl = this.info.imageUrl
      args.appName = this.info.title
      window.YCQQ.shareToQQ(function () {
        console.log('share success')
      }, function (failReason) {
        console.log(failReason)
      }, args)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-popup{background:none;width:100vw;}
</style>



// WEBPACK FOOTER //
// AppShare.vue?eb3ff206